import { Box, Flex, Text, IconButton } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const SwapAndRoute = styled(Flex)`
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  @media (min-width: 1250px) {
    flex-direction: row;
    justify-content: center;
  }
`

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean }>`
  flex-shrink: 0;
  height: fit-content;
  background-color: #fff;

  padding: 0 0px;

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 40px;
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    ${({ $isChartExpanded }) => ($isChartExpanded ? 'padding: 0 40px' : 'padding: 0 40px')};
  }
`
// background-image: linear-gradient(to right, #000, #000), linear-gradient(to right, #34A7E7, #4266FE, #5661FC, #D92EEF);

export const SwapBox = styled(Box)`
  background: ${({ theme }) => theme.colors.darkblue100};
  box-shadow: 0 0 8px -4px #0154fe, 0 0 96px -48px #34a7e7, 0 0 3px 1px #333;
  border: 0px solid;
  border-color: ${({ theme }) => theme.colors.input};
  border-radius: 24px;
  width: 95%;
  margin: auto;
  max-width: 600px;
  padding: 4px;

  padding-left: 8px;
  padding-right: 8px;
  @media (min-width: 1000px) {
    width: 70%;
    padding-left: 12px;
    padding-right: 12px;
  }

  @media (min-width: 1250px) {
    width: 50%;
  }
`

// background-image: linear-gradient(to right, #000, #000), linear-gradient(to right, #34A7E7, #4266FE, #5661FC, #D92EEF);
// background-origin: border-box;
// background-clip: padding-box, border-box;
// background: none;
// background-size: 100% 100%;

export const Label = styled(Text)`
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.secondary};
`

export const StyledBalanceMaxMini = styled.button`
  height: 14px;
  width: 14px;
  background-color: ${({ theme }) => theme.colors.background};
  border: none;
  border-radius: 50%;
  padding: 0.2rem;
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 0.4rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;

  :hover {
    background-color: ${({ theme }) => theme.colors.dropdown};
  }
  :focus {
    background-color: ${({ theme }) => theme.colors.dropdown};
    outline: none;
  }
`

export const SwapHeadText = styled(Text)`
  font-weight: 500;
  color: #fff;
  text-align: left;
  margin-top: 1rem;
  margin-bottom: 12px;
  text-transform: uppercase;
  font-size: 36px;
  @media (min-width: 768px) {
    font-size: 48px;
    margin-bottom: 8px;
  }
`

export const Casing = styled(Flex)`
  background: linear-gradient(-35deg, #0154fe, #fff, #0154fe, #0154fe);
  background-size: 500% 500%;
  padding: 2px;
  border-radius: 14px;
  box-shadow: 0 0 12px #444;
  animation: gradient 5s ease infinite;
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`

export const SwitchIconButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  .icon-up-down {
    display: none;
  }
  &:hover {
    .icon-down {
      display: none;
      fill: white;
    }
    .icon-up-down {
      display: block;
      fill: #37c0df;
    }
  }
`

export const Tabs = styled.div`
  max-width: 100vw !important;
  padding: 0px 0px 24px 0px;
`
